import React from 'react';
import './Categories.css';
import mode from '../assets/mode.png';
import cosmetique from '../assets/cosmetique.png';
import electro from '../assets/electro.png';
import alim from '../assets/alim.png';


const Categories = () => {
  return (
    <section className="categories">
      <h2 className="categories-title">Categories</h2>
      <div className="category-list">
        {/* Mode */}
        <div className="category-card" style={{ backgroundColor: '#FFF9C4' }}>
          <h3 className="category-name">Mode</h3>
          <img src={mode} alt="Mode" className="category-image" />
        </div>


        {/* Soin & Beauté */}
        <div className="category-card" style={{ backgroundColor: '#FFE4E1' }}>
          <h3 className="category-name">Soin & Beauté</h3>
          <img src={cosmetique} alt="Soin & Beauté" className="category-image" />
        </div>


        {/* Electronique */}
        <div className="category-card" style={{ backgroundColor: '#D9F0FF' }}>
          <h3 className="category-name">Electronique</h3>
          <img src={electro} alt="Electronique" className="category-image" />
        </div>


        {/* Alimentaire */}
        <div className="category-card" style={{ backgroundColor: '#DFFFD6' }}>
          <h3 className="category-name">Alimentaire</h3>
          <img src={alim} alt="Alimentaire" className="category-image" />
        </div>
      </div>
    </section>
  );
};


export default Categories;


